import { ChartNoDataIcon } from 'assets/icons';
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const ChartError = ({ message, isError }) => {
  return (
    <ErrorWrap isError={isError}>
      <ChartNoDataIcon />
      <p style={isError ? { color: 'red' } : {}}>
        {isError && 'Error: '}
        {message || 'No data'}
      </p>
    </ErrorWrap>
  );
};

export const ErrorWrap = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  color: ${Palette.PrimaryGray._700};
  font-size: 16px;
  line-height: 14px;

  ${({ isError }) =>
    isError &&
    css`
      svg path,
      svg rect {
        fill: red;
      }
    `}
`;
